<div id="teacher-classes-index" class="container margin-top-1">
  <ng-template #noDataClasses>
    <div class="flex-center">
      {{ "no-classes-yet" | translate }}
    </div>
  </ng-template>
  <mat-card class="margin-top-2" *ngIf="classesLength; else noDataClasses">
    <mat-paginator [pageSize]="15" *ngIf="dataSource.length" [pageIndex]="paginate" (page)="onChangePage($event)"
      [length]="classesLength">
    </mat-paginator>
    <table mat-table [dataSource]="dataSource">
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- teacher Column -->
      <ng-container matColumnDef="teacher">
        <th mat-header-cell *matHeaderCellDef>{{ "teacher" | translate }}</th>
        <td mat-cell *matCellDef="let element">

          <div class="d-flex justify-content-center align-items-center">

            <!-- CHAT -->
            <mat-icon class="margin-right-05 gray cursor-pointer" (click)="onChatTeacher(element)">chat</mat-icon>

            <!-- <div class="flex-start"> -->
              <img [src]="element.teacherImage" class="classes-image margin-top-1 margin-bottom-1"
                *ngIf="element.teacherImage" appErrorImage />
              <div>
                {{ element.teacher }}
              </div>
            <!-- </div> -->
          </div>
        </td>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="lesson">
        <th mat-header-cell *matHeaderCellDef>{{ "class" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.lesson }}</td>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>{{ "date" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.date }}</td>
      </ng-container>

      <!-- type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>{{ "type" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element.type ? "group" : ("individual" | translate) }}
        </td>
      </ng-container>

      <!-- status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ "status" | translate }}</th>
        <td mat-cell *matCellDef="let element" [ngClass]="{
            'text-pendent': element.state == 0,
            'text-accepted': element.state == 1,
            'text-completed': element.state == 2,
            'text-rejected': element.state == 3,
            'text-nonconfirmed': element.state == 6
          }">
           {{ "status-" + element.state | translate }}

          - 
        </td>
      </ng-container>

      <!-- actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="!isMobile">{{ "actions" | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="[0, 1, 3, 6, 7].includes(element.state)">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button *ngIf="
                !isTeacher &&
                (element.element | checkUserCanConfirmClass) &&
                [0, 1, 6, 7].includes(element.state)
              " mat-menu-item (click)="onActionClass(element.element, 'complete')">
              <mat-icon>done</mat-icon>
              <span>{{ "confirm" | translate }}</span>
            </button>
            <button *ngIf="element.state == 1" mat-menu-item (click)="onActionClass(element.element, 'cancel')">
              <mat-icon>block</mat-icon>
              <span>{{ "cancel" | translate }}</span>
            </button>
            <button *ngIf="element.state == 1" [disabled]="!element.canRescheedule" mat-menu-item
              (click)="onActionClass(element.element, 'reschedule')">
              <mat-icon>event_available</mat-icon>
              <span>{{ "reschedule" | translate }}</span>
            </button>
            <button *ngIf="[0, 1, 3, 6].includes(element.state)" mat-menu-item
              (click)="openSupport()">
              <mat-icon>notifications</mat-icon>
              <span>{{ "report-incident" | translate }}</span>
             
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>
</div>
<app-footer></app-footer>